import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlTebGiderAramaComponent } from './ctl-teb-gider-arama/ctl-teb-gider-arama.component';
import { TebGiderService } from './ctl-teb-gider.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
@Component({
  selector: 'dk-ctl-teb-gider',
  templateUrl: './ctl-teb-gider.component.html',
  styleUrls: ['./ctl-teb-gider.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTebGiderAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ],
  providers: [TebGiderService],
})
export class CtlTebGiderComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "TebGider";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code!: string;
  @Input() period!: number;
  @Input() exTmsTasinirKod!: string;
  @Input() validationRulesMap!:any[];
  @Input() validationV2= false;
  @Input() notFoundMessage: string='Bulunamadı!';
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TebGiderService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period']) {
      if(this.period == null) this.showAction = false
      else{
        this.showAction = true
        this.service.setParams(this.period, this.exTmsTasinirKod,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.period, this.exTmsTasinirKod,this.isReadOnly,this.isBindCheck)
      }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Teb Gider)"
      this.showAction = false
    }
        this.service.setParams(this.period, this.exTmsTasinirKod,this.isReadOnly,this.isBindCheck)
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }

  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: string, isSetData?: boolean) {

    this.data = this.service.getData(code,this.control, this.period,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        this.code = result[0].EkoGiderKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError(this.notFoundMessage);
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.isFirst = true
      this.title = result.data.Ad;
      this.data = result.data;
      this.code = result.data.EkoGiderKod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
